
    <template>
      <section class="content element-doc">
        <h2 id="ri-qi-xuan-ze-qi"><a class="header-anchor" href="#ri-qi-xuan-ze-qi">¶</a> 日期选择器</h2>
<p>基础属性和使用方法参考 <a href="https://element.eleme.cn/#/zh-CN/component/date-picker">element-ui </a> <code>el-date-picker</code> 组件文档</p>
<h3 id="mo-ren-kuai-jie-xuan-xiang"><a class="header-anchor" href="#mo-ren-kuai-jie-xuan-xiang">¶</a> 默认快捷选项</h3>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div class=&quot;date-box&quot;&gt;
    &lt;div&gt;
      &lt;span class=&quot;title&quot;&gt;选择范围时间&lt;/span&gt;
      &lt;sh-date-picker type=&quot;daterange&quot; v-model=&quot;value1&quot; pickerOptions /&gt;
    &lt;/div&gt;
    &lt;div&gt;
      &lt;span class=&quot;title&quot;&gt;选择日&lt;/span&gt;
      &lt;sh-date-picker type=&quot;date&quot; v-model=&quot;value2&quot; picker-options /&gt;
    &lt;/div&gt;
  &lt;/div&gt;
&lt;/template&gt;
&lt;script&gt;
  export default {
    data() {
      return {
        value1: '',
        value2: ''
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h3 id="zi-ding-yi-kuai-jie-xuan-xiang"><a class="header-anchor" href="#zi-ding-yi-kuai-jie-xuan-xiang">¶</a> 自定义快捷选项</h3>
<demo-block>
        
        <template slot="source"><element-demo1 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div class=&quot;date-box&quot;&gt;
    &lt;div&gt;
      &lt;span class=&quot;title&quot;&gt;选择范围时间&lt;/span&gt;
      &lt;sh-date-picker type=&quot;daterange&quot; v-model=&quot;value1&quot; :pickerOptions=&quot;pickerOptions1&quot; /&gt;
    &lt;/div&gt;
    &lt;div&gt;
      &lt;span class=&quot;title&quot;&gt;选择日&lt;/span&gt;
      &lt;sh-date-picker type=&quot;date&quot; v-model=&quot;value2&quot; :picker-options=&quot;pickerOptions2&quot; /&gt;
    &lt;/div&gt;
  &lt;/div&gt;
&lt;/template&gt;
&lt;script&gt;
  export default {
    data() {
      return {
        value1: '',
        value2: ''
      }
    },
    computed: {
      pickerOptions1() {
        return {
          shortcuts: [
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setMonth(start.getMonth() - 1)
                picker.$emit('pick', [start, end])
              }
            }
          ]
        }
      },
      pickerOptions2() {
        return {
          disabledDate(time) {
            return time.getTime() &gt; Date.now()
          },
          shortcuts: [
            {
              text: '今天',
              onClick(picker) {
                picker.$emit('pick', new Date())
              }
            },
            {
              text: '昨天',
              onClick(picker) {
                const date = new Date()
                date.setTime(date.getTime() - 3600 * 1000 * 24)
                picker.$emit('pick', date)
              }
            },
            {
              text: '一周前',
              onClick(picker) {
                const date = new Date()
                date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
                picker.$emit('pick', date)
              }
            }
          ]
        }
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h3 id="shu-xing"><a class="header-anchor" href="#shu-xing">¶</a> 属性</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>type</td>
<td>组件类型</td>
<td>string</td>
<td><code>date</code>、<code>daterange</code></td>
<td><code>date</code></td>
</tr>
<tr>
<td>picker-options</td>
<td>快捷选项</td>
<td>object,boolean</td>
<td>见下方说明</td>
<td><code>false</code></td>
</tr>
<tr>
<td>value-format</td>
<td>日期格式</td>
<td>string</td>
<td>见官方文档说明</td>
<td><code>yyyy-MM-dd</code></td>
</tr>
</tbody>
</table>
<h3 id="pickeroptions-kuai-jie-xuan-xiang-can-shu-lei-xing"><a class="header-anchor" href="#pickeroptions-kuai-jie-xuan-xiang-can-shu-lei-xing">¶</a> pickerOptions 快捷选项参数类型</h3>
<table>
<thead>
<tr>
<th>类型</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>boolean</td>
<td><code>true</code> 显示默认快捷选项，<code>false</code> 不显示默认快捷选项</td>
</tr>
<tr>
<td>object</td>
<td>自定义快捷选项,用于覆盖默认快捷选项,具体实现参考示例</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',{staticClass:"date-box"},[_c('div',[_c('span',{staticClass:"title"},[_vm._v("选择范围时间")]),_vm._v(" "),_c('sh-date-picker',{attrs:{"type":"daterange","pickerOptions":""},model:{value:(_vm.value1),callback:function ($$v) {_vm.value1=$$v},expression:"value1"}})],1),_vm._v(" "),_c('div',[_c('span',{staticClass:"title"},[_vm._v("选择日")]),_vm._v(" "),_c('sh-date-picker',{attrs:{"type":"date","picker-options":""},model:{value:(_vm.value2),callback:function ($$v) {_vm.value2=$$v},expression:"value2"}})],1)])]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        value1: '',
        value2: ''
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',{staticClass:"date-box"},[_c('div',[_c('span',{staticClass:"title"},[_vm._v("选择范围时间")]),_vm._v(" "),_c('sh-date-picker',{attrs:{"type":"daterange","pickerOptions":_vm.pickerOptions1},model:{value:(_vm.value1),callback:function ($$v) {_vm.value1=$$v},expression:"value1"}})],1),_vm._v(" "),_c('div',[_c('span',{staticClass:"title"},[_vm._v("选择日")]),_vm._v(" "),_c('sh-date-picker',{attrs:{"type":"date","picker-options":_vm.pickerOptions2},model:{value:(_vm.value2),callback:function ($$v) {_vm.value2=$$v},expression:"value2"}})],1)])]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        value1: '',
        value2: ''
      }
    },
    computed: {
      pickerOptions1() {
        return {
          shortcuts: [
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setMonth(start.getMonth() - 1)
                picker.$emit('pick', [start, end])
              }
            }
          ]
        }
      },
      pickerOptions2() {
        return {
          disabledDate(time) {
            return time.getTime() > Date.now()
          },
          shortcuts: [
            {
              text: '今天',
              onClick(picker) {
                picker.$emit('pick', new Date())
              }
            },
            {
              text: '昨天',
              onClick(picker) {
                const date = new Date()
                date.setTime(date.getTime() - 3600 * 1000 * 24)
                picker.$emit('pick', date)
              }
            },
            {
              text: '一周前',
              onClick(picker) {
                const date = new Date()
                date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
                picker.$emit('pick', date)
              }
            }
          ]
        }
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  